import { render, staticRenderFns } from "./Farmer.vue?vue&type=template&id=aa3d068a"
import script from "./Farmer.vue?vue&type=script&lang=js"
export * from "./Farmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports